import { useQuery } from '@tanstack/react-query';

import getHostCalendarSchedule from 'Api/host/getHostCalendarSchedule';

import getHostCalendarScheduleRequest from './model/request/getHostCalendarScheduleRequest';
import getHostCalendarScheduleResponse from './model/response/getHostCalendarScheduleResponse';

const useGetHostCalendarSchedule = (queryParams) => {
  return useQuery({
    queryKey: ['host-calendar-schedule', queryParams],
    queryFn: async () => {
      const queries = getHostCalendarScheduleRequest(queryParams);

      const response = await getHostCalendarSchedule({ queries });

      const result = getHostCalendarScheduleResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetHostCalendarSchedule;
